const CustomerScreenStages = Object.freeze({
    COMPLETE: 'complete',
    PAY: 'pay',
    SELL: 'sell',
    WAIT: 'wait',
});

module.exports = CustomerScreenStages;
